/*
 * r16p (2026-10-24), DESIGN D:/NecroWork/dm-chats-evidence/DESIGN.md 5.6 / 7.3 (O3): the hint under #776 "Open unread threads" on the
 * slot settings page, on the lib/blankSourceWarning.js pattern - a pure function, never a block. Shown only while #776 is ticked.
 *
 * Opening a conversation on the phone shows its sender "Seen" on Instagram. With #776 off (the default) the worker opens a
 * conversation only to send (or first verify the person of) a reply queued from the Inbox; reading the inbox list marks nothing.
 * With it on, the worker also opens unread conversations during sessions - up to #773 per session - and their senders see "Seen".
 * Nothing here defines a setting: the ids, labels and defaults are the server's metadata (V1's "DM Inbox (Chats)" card).
 */
export const DM_INBOX_IDS = Object.freeze({ inbox: 771, replyMode: 772, threadsPerSession: 773, openUnread: 776 });

export const DM_SEEN_TAG = '[R16P-776]';

const ticked = (v) => v === true || v === 1 || (typeof v === 'string' && ['true', '1'].includes(v.trim().toLowerCase()));

/** null, or { title, text, logLine } while #776 is ticked. `threadsPerSession` = #773's value as the page holds it (or null). */
export function dmOpenUnreadHint(openUnread, threadsPerSession) {
  if (!ticked(openUnread)) return null;
  const n = Number(threadsPerSession);
  const cap = Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
  return {
    title: 'Instagram shows the sender "Seen"',
    text: `With this on, the worker opens unread conversations during sessions${cap ? ` (up to ${cap} per session, #773)` : ''}, and `
      + 'Instagram then shows their senders "Seen". With it off, a conversation is opened only to send a reply you queued in the Inbox; '
      + 'reading the inbox list marks nothing. Turning off read receipts on the phone (Instagram Settings > Messages) stops "Seen" everywhere.',
    logLine: `${DM_SEEN_TAG} #776 on: the "Seen" hint is shown${cap ? ` (#773 = ${cap})` : ''}`,
  };
}
